import { Button } from "@mui/material";
import styled from "@emotion/styled";

export const StyledButtonSecondary = styled(Button)({
  borderRadius: "6px",
  padding: "12px 24px",

  "&:hover": {
    color: "white",
    backgroundColor: "#172339",
  },
});
